
import React, { useState, useEffect, useRef } from "react";

import PrimiumTable from "../TableManagment/PrimiumTable";
import { Link } from "react-router-dom";
const Foodtablemanagment = ({ plan }) => {
    const subscriptionPlan = plan || localStorage.getItem("planType") || "premium"; <PrimiumTable />
    const isMobile = window.innerWidth <= 768;



    const renderComponentByPlan = () => {
        switch (subscriptionPlan.toLowerCase()) {
            case "basic":
                return <PrimiumTable />;
            case "standard":
                return <PrimiumTable />;
            // <Tablereservation />
            case "premium":
                return <PrimiumTable />;
            default:
                return <div>Invalid plan selected</div>;
        }
    };

    return (
        <div className="container-fluid">
            <div className="row">
                {/* Left margin or sidebar */}
                <div className="col-lg-2"></div>

                {/* Main content area (component displayed here) */}
                <div className="col-lg-10" style={{ marginTop: "130px" }}>
                    <p
                        className="breadcrumb maamaas-home-bredcum"
                        style={{
                            position: "fixed",
                                top: window.innerWidth <= 425 ? "50px" : window.innerWidth > 425 && window.innerWidth <= 768 ? "60px" : "64px" ,                            
                            left: "2vw",
                            width: "100%",
                            backgroundColor: "#fff",
                            zIndex: 100,
                            padding: "10px 0",
                            fontSize: isMobile ? "16px" : "18px",
                            fontWeight: isMobile ? "normal" : "bold",
                            textAlign: "center",
                            margin: 0,
                        }}
                    >
                        {/* <Link
                            to="/Newmainlandingpage"
                            style={{
                                color: "purple",
                                fontWeight: "bold",
                                textDecoration: "none",
                            }}
                        >
                            Home
                        </Link> */}
                        {/* <span className="separator"> &gt; </span> */}
                        <Link
                            to="/fooddashboard"
                            style={{
                                color: "purple",
                                fontWeight: "bold",
                                textDecoration: "none",
                            }}
                        >
                            Food & Beverages
                        </Link>
                        <span className="separator"> &gt; </span>
                        <Link

                            style={{
                                color: "purple",
                                fontWeight: "bold",
                                textDecoration: "none",
                            }}
                        >
                            Table_Management
                        </Link>

                    </p>
                    {renderComponentByPlan()}
                </div>

                {/* Optional right-side content or spacing */}
                {/* <div className="col-lg-3"></div> */}

            </div>
        </div>
    );
};

export default Foodtablemanagment;

